import React, {useMemo, useState} from "react"
import { connect } from "react-redux"
import classNames from "classnames"
import pluralize from "pluralize";
import {
  toggleSecondPartSidebarAction
} from "../../../state/application/actions"
import { toggleProductsViewAction } from "../../../state/product/actions"
import HeaderSearchResultsSidebar from "./HeaderSearchResultsSidebar"
import Loader from "../../shared/Loader"
import {
  getSearchFormValuesByState,

  ADVANCED_SEARCH_SCOPE_CONFIGURATION_FIELDS as SCOPE_CONFIGURATION_FIELDS, isApplicableFieldFromConfigurations,
  isSearchingForProductId,
  isUpdateResultsSearchAvailable,
  isUpdateResultsSearchModeAvailable,
} from "../../../helpers/configurationHelper";
import FooterSearchResultsSidebar from "./FooterSearchResultsSidebar";
import {
  isSearchResultsSidebarToggleVisibleByState, isSearchSidebarToggleVisibleByState,
  SEARCH_RESULTS_SIDEBAR_TITLE
} from "../../../helpers/sidebarsHelper";
import {formatCompactNumber} from "../../../helpers/utilsHelper";
import CheckoutButton from "../../shared/checkout/CheckoutButton";
import {
  getAllSelectableProductImagesFrom,
  isInterferometricStackSearchResults
} from "../../../helpers/searchResultsHelper";
import {
  ProductImageStacType,
  SearchResultsType
} from "../../../types/product";
import BodySearchResultsSidebar from "./BodySearchResultsSidebar";
import {ConfigurationsType} from "../../../types/configurations";
import {CartOrderType} from "../../../types/cart";
import {AppParametersType} from "../../../types/app";
import translations from "../../../translations";
import DownLoadSearchResultsButton from "../../shared/checkout/DownLoadSearchResultsButton";
import { ShapeType } from "../../../types/shape";

interface PropsType {
  configurations: ConfigurationsType,
  ordersSubmitted: CartOrderType[],
  searchResults: SearchResultsType,
  isSearchResultsSidebarToggleVisible: boolean,
  isSearchSidebarToggleVisible: boolean,
  sidebarSecondPartShown: boolean,
  isSearchingResults: boolean,
  searchError: string,
  searchFormValues: any,
  toggleSecondPartSidebarActionHandler: any,
  appParameters: AppParametersType,
  language: string,
  selectedArea: ShapeType,
  selectedProducts: ProductImageStacType[]
  loadingScenes,
  lastShapeAoi
}

const SearchResultsSidebar = (props: PropsType) => {
  const {
    configurations,
    ordersSubmitted,
    isSearchSidebarToggleVisible,
    sidebarSecondPartShown,
    searchResults,
    isSearchingResults,
    searchFormValues,
    isSearchResultsSidebarToggleVisible,
    searchError,
    toggleSecondPartSidebarActionHandler,
    appParameters,
    language,
    selectedArea,
    selectedProducts,
    loadingScenes,
    lastShapeAoi
  } = props;

  const [isLoadingCutscenes, setIsLoadingCutscenes] = useState(false);

  useMemo(() => {
    setIsLoadingCutscenes(!!loadingScenes.length);
  }, [loadingScenes]);

  const isInterferometricStackSearch = isInterferometricStackSearchResults(searchResults);

  const totalItemsCount = (searchResults && searchResults.totalItems) || 0;

  let bodySearchResultsSidebar = <Loader containerClassName="row mx-0" spinnerClassName="big" />;
  if (sidebarSecondPartShown && !isSearchingResults && !isLoadingCutscenes) {
    if (totalItemsCount > 0) {
      bodySearchResultsSidebar = (
        <>
          <HeaderSearchResultsSidebar
            searchResults={searchResults}
            isInterferometricStackSearch={isInterferometricStackSearch}
          />
          <BodySearchResultsSidebar
            searchResults={searchResults}
            isInterferometricStackSearch={isInterferometricStackSearch}
          />
          <FooterSearchResultsSidebar
            searchResults={searchResults}
            isInterferometricStackSearch={isInterferometricStackSearch}
          />
        </>
      )
    } else {
      bodySearchResultsSidebar = (
        <div className="row m-0">
          <div className="col-12 py-4 px-3">
            <h6>{searchError}</h6>
          </div>
        </div>
      );
    }
  }
  console.log("SEARCH", searchFormValues)
  console.log("ORDER", ordersSubmitted)
  return (
    <>
      <button
        className={classNames("sidebar-toggle-btn second next-to-secondpart remove-btn-defaults search-results-sidebar-toggle", {
          "d-none": !(!isSearchSidebarToggleVisible && isSearchResultsSidebarToggleVisible)
        })}
        type="button"
        onClick={() => toggleSecondPartSidebarActionHandler(true)}
      >
        <span className="quantity">{formatCompactNumber(totalItemsCount)}</span>
        <span>{translations(SEARCH_RESULTS_SIDEBAR_TITLE, language)}</span>
        <svg><use xlinkHref="#right_arrow-icon" fill="#9A9BA6" /></svg>
      </button>

      <div
        className={classNames("wrapper-search-results", {
          "d-none": !sidebarSecondPartShown,
          // "freezed": isLoadingCutscenes
        })}
      >
        {/*{isLoadingCutscenes &&*/}
        {/*    <div id="loading-spinner"></div>*/}
        {/*}*/}
        <div className="sidebar-header d-flex justify-content-between align-items-center px-3 py-4">
          <h6
            className="title-like text-uppercase m-0 text-center"
            title={translations(SEARCH_RESULTS_SIDEBAR_TITLE, language)}
            style={{paddingLeft: `${isSearchSidebarToggleVisible ? 170 : 0}px`}}
          >
            {translations(SEARCH_RESULTS_SIDEBAR_TITLE, language)}
          </h6>
          <button className="sidebar-close-btn remove-btn-defaults" type="button" onClick={() => toggleSecondPartSidebarActionHandler(false)}>
            <svg><use xlinkHref="#left_arrow-icon" fill="#9A9BA6" /></svg>
            <span>{translations("closeLeftSearchBar", language)}</span>
          </button>
        </div>
        {bodySearchResultsSidebar}
      </div>
    </>
  )
};

const mapStateToProps = (state) => ({
  appParameters: state.application.appParameters,
  configurations: state.application.configurations,
  ordersSubmitted: state.cart.ordersSubmitted,
  sidebarSecondPartShown: state.application.sidebarSecondPartShown,
  searchResults: state.product.searchResults,
  isSearchingResults: state.product.isSearchingResults,
  searchError: state.product.error,
  searchFormValues: getSearchFormValuesByState(state),
  isSearchSidebarToggleVisible: isSearchSidebarToggleVisibleByState(state),
  isSearchResultsSidebarToggleVisible: isSearchResultsSidebarToggleVisibleByState(state),
  language: state.application.appParameters.language,
  loadingScenes: state.geoMap.availableLoadingScenes,
  lastShapeAoi: state.geoMap.lastShape
});

const mapDispatchToProps = (dispatch) => ({
  toggleSecondPartSidebarActionHandler: (e) => dispatch(toggleSecondPartSidebarAction(e)),
  toggleProductsViewActionHandler: (e) => dispatch(toggleProductsViewAction(e)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchResultsSidebar)
